import { format, parse } from 'date-fns';
import * as React from 'react';

export interface IDatetimeCellProps {
  time: string;
}

export function DatetimeCell({ time }: IDatetimeCellProps) {
  return <>{time ? format(parse(time), 'YYYY-MM-DD HH:mm') : '-'}</>;
}
